import { render, staticRenderFns } from "./MemberRank.vue?vue&type=template&id=6acbafca&"
import script from "./MemberRank.vue?vue&type=script&lang=js&"
export * from "./MemberRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports